import { Component } from '@angular/core';
import { AlertController,App} from 'ionic-angular';
import { StorageService } from '../../../../providers/service/storageservice';
import { LoginPage } from '../../../login/login/login';
import { AppState } from '../../../../app/app.global';
import { Utils} from '../../../../providers/service/utils';
import { TabsPage } from '../../../tabs/tabs/tabs';
import { ToastAlert } from '../../../../providers/util/toastalert';
import { HttpService } from '../../../../providers/service/httpservice';
import { CHECK_IS_WEAK_PWD, SAVE_UPDATE_PWD2, PWD_COM_POLICY } from '../../../../providers/config/serviceurl';

@Component({
  selector: 'modify-pwd-page',
  templateUrl: 'modifyPwd.html'
})
export class ModifyPasswordPage {
	user:any =null;
	accountKey:string;
	accountPwd:string;
	newPwd:string;
	confirmPwd:string;
	policyInfo:string;
	constructor (private alertCtrl: AlertController,public appCtrl: App,public global: AppState,
		private httpService:HttpService, public toastAlert: ToastAlert) {
		this.user = StorageService.getObj('currentUser');
		this.accountKey = StorageService.getObj('accountKey');
	}
	//当将要进入页面时触发
	ionViewWillEnter(){
		this.getPwdComPolicy();
	}
	modifyPwd(){
		if (!this.accountKey) {
            let alert = this.alertCtrl.create({
				message: '请输入原密码',
				buttons: ['确定']
			});
			alert.present();
			return false;
		}
		if (!this.newPwd) {
            let alert = this.alertCtrl.create({
				message: '请输入新密码',
				buttons: ['确定']
			});
			alert.present();
			return false;
		}
		if (!this.confirmPwd) {
            let alert = this.alertCtrl.create({
				message: '请输入确认密码',
				buttons: ['确定']
			});
			alert.present();
			return false;
		}
		if(this.newPwd!=this.confirmPwd){
			let alert = this.alertCtrl.create({
				message: '两次输入的的新密码不一致',
				buttons: ['确定']
			});
			alert.present();
			return false;
		}

		// 修改密码=>参数：账号，新密码，原密码，确认密码
		let params = { accountKey: Utils.base64Encode(this.accountKey), accountPwd: Utils.base64Encode(this.accountPwd), newPwd: Utils.base64Encode(this.newPwd), confirmPwd: Utils.base64Encode(this.confirmPwd) };
		this.httpService.get2(SAVE_UPDATE_PWD2, params).then(anyObj =>this.handleModifyPwd(anyObj));

		// if(this.newPwd!=this.confirmPwd){
		// 	let alert = this.alertCtrl.create({
		// 		message: '两次输入的的新密码不一致',
		// 		buttons: ['确定']
		// 	});
		// 	alert.present();
		// }else if(this.accountPwd == ""){
		// 	let alert = this.alertCtrl.create({
		// 		message: '请输入原密码',
		// 		buttons: ['确定']
		// 	});
		// 	alert.present();
		// }else {
		// 	// 修改密码=>参数：账号，新密码，原密码，确认密码
		// 	let params = { accountKey: Utils.base64Encode(this.accountKey), accountPwd: Utils.base64Encode(this.accountPwd), newPwd: Utils.base64Encode(this.newPwd), confirmPwd: Utils.base64Encode(this.confirmPwd) };
		//     this.httpService.get2(SAVE_UPDATE_PWD2, params).then(anyObj =>this.handleModifyPwd(anyObj));
		// }
	}
	handleModifyPwd(obj:any){
		console.log('data === ' + JSON.stringify(obj));
		if(obj){
			if(obj.hasOwnProperty('error')){
				this.toastAlert.alertMsg(obj.error.errors[0].message, 'middle', 3000); 
			}else{
				let alert = this.alertCtrl.create({
					message: obj.data.success,
					buttons: [
						{		 
							text:'确定',
							handler:() =>{
							   this.appCtrl.getRootNav().setRoot(LoginPage);
							}
						}
					]
			  	});
				alert.present(); 
			}
		}
	}

	getPwdComPolicy() {
		let params = { accountKey: this.accountKey };
		this.httpService.get2(PWD_COM_POLICY, params).then(data =>{
			this.policyInfo = data.policyInfo;
			console.log('--- 密码策略： --- ' + JSON.stringify(data));
		});
	}

}



// WEBPACK FOOTER //
// ./src/pages/login/password/modify/modifyPwd.ts